import * as React from 'react';
import { ServiceSummary } from '../../../features/service-summary';
const RefundableTicket = ({ onServiceDelete }) => {
    return (React.createElement(ServiceSummary, { serviceType: "RefundableTicket", onDelete: onServiceDelete }, content => React.createElement(React.Fragment, null, content)));
};
export default RefundableTicket;
